import { render, staticRenderFns } from "./compbesure.vue?vue&type=template&id=bc2878fc"
import script from "./compbesure.vue?vue&type=script&lang=js"
export * from "./compbesure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports